var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "00-Elements-/-Icons-/-book-icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.68666,2.70449996 C12.4229,1.57994996 15.355,0.999999955 18.3182,0.999999955 L18.4204,0.999999955 C18.7405,0.999999955 19,1.25948996 19,1.57958996 L19,16.2659 C19,16.6713 18.6713,17 18.2659,17 L17.3145,17 C15.1599,17 13.0175,17.2954 10.9468,17.8765 C10.898,18.18 10.8044,18.3871 10.6247,18.5309 C10.2494,18.8311 9.68659,18.7045 8.56097999,18.4512 L6.55555998,18 L2.64568996,17.2962 C1.85897996,17.1546 1.46562996,17.0838 1.23280996,16.8054 C0.999999955,16.5269 0.999999955,16.1272 0.999999955,15.3279 L0.999999955,3.39213997 C0.999999955,2.28316996 0.999999955,1.72867996 1.35857996,1.42887996 C1.71714996,1.12908996 2.26286996,1.22731996 3.35430997,1.42376996 L6.55555998,1.99999995 L9.68666,2.70449996 Z M11,4.33628997 C12.9246,3.60916997 14.9469,3.17294997 17,3.04199997 L17,15.0019 C14.9739,15.0269 12.9598,15.2925 11,15.792 L11,4.33628997 Z M8.99999997,4.59999997 L8.99999997,16.5 L6.95240998,16.0393 L2.99999997,15.3279 L2.99999997,3.39213997 L6.15869998,3.96070997 L8.99999997,4.59999997 Z",
  id: "book-icon",
  fill: "#FFFFFF"
}));

function SvgBookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.985bfc00.svg";
export { ForwardRef as ReactComponent };